import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { threshold: { type: Number, default: 8 } }

  connect() {
    this.handleScroll = this.handleScroll.bind(this)
    this.autoScrollEnabled = true

    // Start at bottom if content overflows
    this.scrollToBottom()

    this.element.addEventListener("scroll", this.handleScroll)

    this.observer = new MutationObserver(() => {
      if (this.shouldAutoScroll()) {
        this.scrollToBottom()
      }
    })

    this.observer.observe(this.element, { childList: true, subtree: true })
  }

  disconnect() {
    if (this.observer) {
      this.observer.disconnect()
      this.observer = null
    }
    this.element.removeEventListener("scroll", this.handleScroll)
  }

  handleScroll() {
    // Keep auto-scroll enabled only when user is at (or near) the bottom
    this.autoScrollEnabled = this.isAtBottom()
  }

  shouldAutoScroll() {
    return this.autoScrollEnabled || this.isAtBottom()
  }

  isAtBottom() {
    const distance = this.element.scrollHeight - this.element.scrollTop - this.element.clientHeight
    return distance <= this.thresholdValue
  }

  scrollToBottom() {
    this.element.scrollTop = this.element.scrollHeight
  }
}

